<template>
  <div class="criterio-select-lojas">
    <v-row>
      <v-col class="py-0" align="center">
        <select-geolocation
          :type="componentParams"
          :selected.sync="geos"
          :disable-save="disableSave"
          :tooltip-primary-button="tooltipPrimaryButton"
          :tooltip-primary-button-message="tooltipPrimaryButtonMessage"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty'

export default {
  components: {
    SelectGeolocation: () => import('@/components/geo-selectors/SelectGeolocation.vue'),
  },
  props: {
    label: String,
    currentIndex: Number,
    initialValue: {
      type: [Array, Number],
      default: () => [],
    },
    values: {
      type: [Array, Number],
      default: () => [],
    },
    componentParams: {
      type: String,
      required: true,
      validator: (val) => ['federative_unit', 'city', 'neighborhood'].includes(val),
    },
    disableSave: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    geos: [],
  }),

  computed: {
    tooltipPrimaryButton() {
      return this.disableSave
    },
    tooltipPrimaryButtonMessage() {
      return this.disableSave ? 'Não é possível alterar um segmento estático' : ''
    },
  },

  watch: {
    geos(geos) {
      this.$emit('input', {
        currentValue: geos,
        currentChildren: this.values[0],
        currentIndex: this.currentIndex,
      })
      this.validate()
    },
  },

  created() {
    if (!isEmpty(this.initialValue)) {
      this.setInitialState(this.initialValue)
    }
  },

  methods: {
    validate() {
      this.$emit('validate', { isValid: this.isValid(), currentIndex: this.currentIndex })
    },

    isValid() {
      return Boolean(this.geos && this.geos.length)
    },

    async setInitialState(geos) {
      this.geos = geos
    },
  },
}
</script>

<style lang="scss">
.criterio-select-lojas {
  .select-container {
    padding: 0 15px;
  }
}
</style>
